import address from './address'


var index = {
    data() {
        return {

        }
    },
    fetch() {

    },
    modules: {
        address
    }
}

export default index;